import React from 'react';
import { Route,Redirect } from 'react-router-dom'
import { getCookie } from '../services/helper/Helper';

export const AuthRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      // Synchronous check: if the auth cookie exists, render the component.
      // The async session validation happens inside the component itself.
      const hasToken = getCookie(btoa("TAWAJ"));
      return hasToken ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location }
          }}
        />
      )
    }}
  />
);
